import React, { StrictMode } from 'react';

import PropTypes from 'prop-types';
import Main from './Main';

export default function Index({ affiliateId }) {
  return (
    <StrictMode>
      <Main affiliateId={affiliateId} />
    </StrictMode>
  );
}

Index.propTypes = {
  affiliateId: PropTypes.number.isRequired,
};
